const CERTIFICATE_EQUIVALENCE = {
	user: {
		'vca-user-vol': ['ssc-user-vol'],
		'ssc-user-vol': ['vca-user-vol'],
		'vca-user-basis': ['ssc-user-basis'],
		'ssc-user-basis': ['vca-user-basis'],
	},
	group: {
		'vca-company-p': ['ssc-company-p', 'mase', 'iso-45001'],
		'ssc-company-p': ['vca-company-p', 'mase', 'iso-45001'],
		'mase': ['vca-company-p', 'ssc-company-p', 'iso-45001'],
		'iso-45001': ['vca-company-p', 'ssc-company-p', 'mase'],
		'vca-company-**': ['ssc-company-**'],
		'ssc-company-**': ['vca-company-**'],
		'vca-company-*': ['ssc-company-*'],
		'ssc-company-*': ['vca-company-*'],
		'vca-company-u': ['ssc-company-u'],
		'ssc-company-u': ['vca-company-u'],
	}
};

const CERTIFICATE_HIERARCHY = {
	user: {
		'vca-user-vol': ['vca-user-basis'],
		'ssc-user-vol': ['ssc-user-basis'],
	},
	group: {
		'vca-company-p': ['vca-company-**', 'vca-company-*', 'vca-company-u'],
		'vca-company-**': ['vca-company-*', 'vca-company-u'],
		'vca-company-*': ['vca-company-u'],
		'ssc-company-p': ['ssc-company-**', 'ssc-company-*', 'ssc-company-u'],
		'ssc-company-**': ['ssc-company-*', 'ssc-company-u'],
		'ssc-company-*': ['ssc-company-u'],
	}
};

export const getSatisfiedDocumentTypes = (model, certificates, documents) => {
	const selectedCertificates = certificates.filter(cert => cert.selected !== false);
	const validDocuments = documents.filter(doc => doc.validity !== false);

	const allTypes = [
		...selectedCertificates.map(cert => cert.type),
		...validDocuments.map(doc => doc.type),
	];

	const satisfiedTypes = new Set(allTypes);
	const toProcess = [...allTypes];

	while (toProcess.length > 0) {
		const type = toProcess.shift();

		if (CERTIFICATE_EQUIVALENCE[model][type]) {
			CERTIFICATE_EQUIVALENCE[model][type].forEach(equivalentType => {
				if (!satisfiedTypes.has(equivalentType)) {
					satisfiedTypes.add(equivalentType);
					toProcess.push(equivalentType);
				}
			});
		}

		if (CERTIFICATE_HIERARCHY[model][type]) {
			CERTIFICATE_HIERARCHY[model][type].forEach(lowerType => {
				if (!satisfiedTypes.has(lowerType)) {
					satisfiedTypes.add(lowerType);
					toProcess.push(lowerType);
				}
			});
		}
	}

	return Array.from(satisfiedTypes);
};

export const flattenRequirementTypes = (requirementTypes) => {
	const flattened = [];

	requirementTypes.forEach(item => {
		if (Array.isArray(item)) {
			flattened.push(...item);
		} else {
			flattened.push(item);
		}
	});

	return flattened;
};

export const isRequirementGroupSatisfied = (requirementGroup, satisfiedTypes) => {
	if (Array.isArray(requirementGroup)) {
		return requirementGroup.some(type => satisfiedTypes.includes(type));
	} else {
		return satisfiedTypes.includes(requirementGroup);
	}
};

export const formatRequirementGroup = (requirementGroup, getDisplayName, separator = ' or ') => {
	if (Array.isArray(requirementGroup)) {
		return requirementGroup.map(type => getDisplayName(type)).join(separator);
	} else {
		return getDisplayName(requirementGroup);
	}
};

export const getUnsatisfiedRequirements = (requirementTypes, satisfiedTypes) => {
	return requirementTypes.filter(requirementGroup =>
		!isRequirementGroupSatisfied(requirementGroup, satisfiedTypes),
	);
};

export const getTypesAcceptableForRequirements = (model, requiredTypes) => {
	const allCertTypes = [
		...Object.keys(CERTIFICATE_EQUIVALENCE.user),
		...Object.keys(CERTIFICATE_EQUIVALENCE.group),
		...Object.keys(CERTIFICATE_HIERARCHY.user),
		...Object.keys(CERTIFICATE_HIERARCHY.group),
	];

	const acceptableTypes = new Set();

	const flattenedTypes = flattenRequirementTypes(requiredTypes);

	flattenedTypes.forEach(requiredType => {
		acceptableTypes.add(requiredType);

		allCertTypes.forEach(certType => {
			const satisfiedTypes = getSatisfiedDocumentTypes(model,
				[{ type: certType, selected: true }],
				[],
			);

			if (satisfiedTypes.includes(requiredType)) {
				acceptableTypes.add(certType);
			}
		});
	});

	return Array.from(acceptableTypes);
};
